<template>
  <listing-layout :actionBar="true">
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Judge Application</h1>
    </div>
    <div slot="content">
      <download-blank/>
      <application-form :memberDetails="memberDetails" v-if="memberDetails"/>
      <div class="bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3" v-else>
        <div class="text-center p-2">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </listing-layout>
</template>

<script>

import GETSTORE from '@/store/memberProfileStore.js'
import listingLayout from '@/components/ListingLayout'
import DownloadBlankAlert from "./components/DownloadBlankAlert"
import JudgeApplicationForm from "./components/JudgeApplicationForm"

export default {
  name: 'JudgeApplication',
  mixins: [GETSTORE],
  components: {
    'listing-layout': listingLayout,
    'download-blank': DownloadBlankAlert,
    'application-form': JudgeApplicationForm
  },
  data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role
    }
  },
  mounted() {
    if (!this.checkHasFinancialMembers) {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  },
  methods: {
    checkHasFinancialMembers() {
      return !!this.memberDetails.secondaries.find(member => member.financial) || this.memberDetails.financial
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Judges/Application/JudgeApplication.vue